(function () {
	'use strict';
	angular
		.module('sodCommon')
		.directive('sodDaterangePicker', sodDaterangePicker);

	function sodDaterangePicker(lodash, ModalService) {
		return {
			restrict: 'E',
			require: 'ngModel',
			scope: {
				options: '=?'
			},
			templateUrl: 'common/components/sod-daterange-picker',
			link: function(scope, elem, attr, ctrl) {
				scope.cData = {
					model: '',
					default_options: {
						date_format: 'D MMM YYYY',
						label: {
							select_date: 'Select Date',
							change_date: 'Change Date'
						}
					},
					selectDate: selectDate,
				};

				var options = angular.merge(scope.cData.default_options, lodash.get(scope, 'options', {}));
				scope.cData.options = options;

				ctrl.$render = function() {
					scope.cData.model = ctrl.$viewValue;
				};

				scope.$watch('cData.model', function() {
					console.log('watch triggered');
						scope.cData.select_date_text =
							(lodash.isEmpty(scope.cData.model))
								? options.label.select_date
								: options.label.change_date;
				});

				function selectDate() {
					ModalService.showModal({
						templateUrl: 'common/components/dialog/sod-daterange-picker-modal',
						controller: 'DateRangePickerCtrl',
						controllerAs: 'drpVm',
						inputs: {
							options: options,
							model: scope.cData.model
						},
						bindToController: true,
					}).then(function(modal) {
						modal.element.show();
						modal.close.then(function(res) {
							if (res !== false) {
								ctrl.$setViewValue(res);
								ctrl.$render();
							}
						})
					});
				}

			}
		};
	}
})();